import React, {useEffect} from "react";
import {Col, Row, Table, DatePicker} from "antd";

import {formatMoney} from "../../../../../../utils/moneyHelper";
import {useCourierWalletSubTab} from "./useCourierWalletSubTab";
import moment from "moment";
import locale from "antd/es/date-picker/locale/tr_TR";
import {WalletTransactions} from "./walletTransactions/WalletTransactions";

const {RangePicker} = DatePicker;
export const CourierWalletSubTab = ({
    courier,
    canRender = false,
    walletData,
    walletStartDateRecall
}) => {
    const {
        wallet,
        walletLoading,
        selectedDateRange,
        handleDateRangeChange
    } = useCourierWalletSubTab({courier, canRender, walletData});

    useEffect(() => {
        if (canRender && wallet) {
            handleDateRangeChange([moment(wallet?.createdAt), selectedDateRange?.[1]]);
        }
    }, [walletStartDateRecall]);

    const renderTransactionTable = (dailyTransaction, aa, bb) => {
        const {_id: dailyTransactionId} = dailyTransaction;
        return (
            <>
                <WalletTransactions
                    externalId={courier?._id}
                    dailyTransactionId={dailyTransactionId}
                />
            </>
        );
    };

    return (
        <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <RangePicker
                    locale={locale}
                    format="DD/MM/YYYY"
                    value={selectedDateRange}
                    onChange={handleDateRangeChange}
                />
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Table
                    loading={walletLoading}
                    rowKey="_id"
                    expandable={{
                        expandedRowRender: renderTransactionTable,
                        defaultExpandedRowKeys: ["0"]
                    }}
                    pagination={false}
                    scroll={{x: 902}}
                    columns={[
                        {
                            title: "Gün",
                            dataIndex: "date",
                            key: "date",
                            width: 100,
                            render: date => (date ? moment(date).format("DD.MM.YYYY") : "-")
                        },
                        {
                            title: "Başlangıç Bakiyesi",
                            dataIndex: ["metaData", "startBalanceOfDay"],
                            key: "startBalanceOfDay",
                            width: 150,
                            render: startBalanceOfDay => formatMoney({amount: startBalanceOfDay})
                        },
                        {
                            title: "Bitiş Bakiyesi",
                            dataIndex: ["endBalanceOfDay"],
                            key: "endBalanceOfDay",
                            width: 150,
                            render: endBalanceOfDay => formatMoney({amount: endBalanceOfDay})
                        },
                        {
                            title: "Para Çekme",
                            dataIndex: "totalWithdrawAmount",
                            key: "totalWithdrawAmount",
                            width: 150,
                            render: totalWithdrawAmount =>
                                formatMoney({amount: totalWithdrawAmount})
                        },
                        {
                            title: "Nakit Tahsilat",
                            dataIndex: "totalCashOrderAmount",
                            key: "totalCashOrderAmount",
                            width: 150,
                            render: totalCashOrderAmount =>
                                formatMoney({amount: totalCashOrderAmount})
                        },
                        {
                            title: "Faturalanmamış Nakit Kümülatif",
                            dataIndex: ["metaData", "cumulativeWithdrawCashAmount"],
                            key: "cumulativeWithdrawCashAmount",
                            width: 150,
                            render: cumulativeWithdrawCashAmount =>
                                formatMoney({amount: cumulativeWithdrawCashAmount})
                        },
                        {
                            title: "Kazanç",
                            dataIndex: "totalDailyEarningAmount",
                            key: "totalDailyEarningAmount",
                            width: 150,
                            render: totalDailyEarningAmount =>
                                formatMoney({amount: totalDailyEarningAmount})
                        }
                        /* {
                            title: "Günlük İşlem Tutarı",
                            dataIndex: "balance",
                            key: "balance",
                            width: 150,
                            render: balance => formatMoney({amount: balance})
                        } */
                    ]}
                    dataSource={
                        wallet?.dailyTransactions?.sort((a, b) =>
                            moment(b.date).diff(moment(a.date))
                        ) || []
                    }
                />
            </Col>
        </Row>
    );
};
